import DTHForm from "./DTHForm";
import "react-toastify/dist/ReactToastify.css";
import Main from "./Main";
import { doRechargeOperatorByNumber, dth_fetch_info, rechargeOperatorByNumber } from "../api/rechages.Api";

import { useState, useEffect } from "react";
import { useWallet } from "../context/walletContext";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import { useParams } from "react-router-dom";
import { useNotify } from "../context/NotifyContext";
import { Autocomplete, TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";

const DTHRecharge = () => {
  const { slug } = useParams();
  const [dthNumber, setDthNumber] = useState("");
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingFinal, setLoadingFinal] = useState(false);
  const { refreshWalletCart } = useWallet();
  const { notify } = useNotify();
  const [operators, setOperators] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("DTH");

  // Load operators on mount
  useEffect(() => {
    const loadOperators = async () => {
      try {
        const res = await rechargeOperatorByNumber();
        if (res?.success) {
          setOperators(res.data?.info || []);
          // Get unique categories
          const uniqueCategories = [
            ...new Set(res.data?.info.map((op) => op.category)),
          ];
          setCategories(uniqueCategories);
        } else {
          notify(res.message || "Failed to fetch operators", "error");
        }
      } catch (err) {
        notify(err.message || "Error fetching operators", "error");
      }
    };
    loadOperators();
  }, []);

  // Reset details if operator or number changes
  useEffect(() => {
    setDetails(null);
  }, [selectedOperator, dthNumber]);

  // Fetch DTH info
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!selectedOperator || !dthNumber.trim()) {
  //     notify("Please fill all fields", "warning");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const payload = { mobile: dthNumber, op: selectedOperator.name };
  //     const result = await dth_fetch_info(payload);

  //     if (result.success) {
  //       setDetails(result.data?.info?.[0] || {});
  //       notify(result.message || "DTH info fetched successfully", "success");
  //     } else {
  //       notify(result.message || "Unable to fetch DTH info", "error");
  //     }
  //   } catch (err) {
  //     notify(err?.message || "Unexpected error occurred", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


    const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOperator || !dthNumber.trim()) {
      notify("Please fill all fields", "warning");
      return;
    }

    setLoading(true);
    setDetails(null);

    try {
      const payload = { mobile: dthNumber, op: selectedOperator.name };
      const result = await dth_fetch_info(payload);

      if (result.success) {
        const info = result.data?.info;

        if (!info || info.status === 0 || info.status === "0") {
          // Case: Customer Not Found
          notify(info?.desc || "Customer not found", "error");
          setDetails(null);
        } else {
          // Case: Customer data fetched successfully
          setDetails(info);
          notify(result.message || "DTH info fetched successfully", "success");
        }
      } else {
        // API returned success: false
        notify(result.message || "Unable to fetch DTH info", "error");
      }
    } catch (err) {
      // Network or unexpected error
      notify(err?.response?.data?.message || err.message || "Unexpected error occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  // Recharge API call
  const handleRechargeAPI = async (amount) => {
    if (!dthNumber) return notify("DTH Number is required", "warning");
    if (!selectedOperator) return notify("Operator is required", "warning");
    if (!amount) return notify("Amount is required", "warning");
  

    setLoadingFinal(true);
    try {
      const payload = {
        mobile: dthNumber,
        operator: selectedOperator.id,
        amount,
        category: selectedCategory,
      };

      const result = await doRechargeOperatorByNumber(payload);

      if (result.success) {
        notify(result.message || "Recharge successful", "success");
        refreshWalletCart();
        setDetails(null);
        setDthNumber("");
        setSelectedOperator(null);
      } else {
        notify(result.message || "Recharge failed", "error");
      }
    } catch (err) {
      notify(err?.message || "Unexpected error occurred", "error");
    } finally {
      setLoadingFinal(false);
    }
  };

  return (
    <Main showRightPanel={false}>
      <AppBreadcrumbs
        items={[
          { label: "Dashboard", to: "/" },
          { label: "Recharge & Bills - 1" },
          { label: "DTH Recharge" },
        ]}
      />

      <div className="flex flex-col lg:flex-row gap-6 items-start justify-start mt-4">
        {/* Operator & DTH Number Form */}
        <div className="ds-card p-4 sm:p-6 w-full max-w-[230px] lg:max-w-[260px]">
          <h2 className="text-[14px] sm:text-md font-semibold  mb-3 whitespace-nowrap">
            DTH Recharge
          </h2>
          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Category Select */}
            <FormControl fullWidth size="small">
              <InputLabel>Category</InputLabel>
              <Select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                label="Category"
              >
                {categories.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Operator Autocomplete */}
            <Autocomplete
              options={operators.filter((op) => op.category === selectedCategory)}
              getOptionLabel={(op) => op.name || ""}
              value={selectedOperator}
              onChange={(e, val) => setSelectedOperator(val)}
              renderInput={(params) => (
                <TextField {...params} size="small" placeholder="Select Operator" />
              )}
            />

            {/* DTH Number Input */}
            <TextField
              size="small"
              fullWidth
              label="DTH Number"
              value={dthNumber}
              onChange={(e) => setDthNumber(e.target.value)}
            />

            <button
              type="submit"
              disabled={loading || details}
              className="ds-btn ds-btn-primary ds-btn-block"
            >
              {loading ? "Loading..." : "Get DTH Info"}
            </button>
          </form>
        </div>

        {/* Show DTH Info & Recharge Form */}
        {details && (
          <div className="w-full max-w-sm">
            <DTHForm data={details} loading={loadingFinal} onRecharge={handleRechargeAPI} />
          </div>
        )}
      </div>
    </Main>
  );
};

export default DTHRecharge;
